import { FC, memo, useCallback, useEffect, useState } from "react";
import styled from "styled-components";

interface IProps {
  date: string;
}

const RootContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const Timer: FC<IProps> = memo(({ date }) => {
  const [time, setTime] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const formatTime = useCallback((time: string) => {
    return time.length === 1 ? `0${time}` : time;
  }, []);

  const getTime = useCallback(() => {
    const diff = Date.now() - Date.parse(date);
    const hours = formatTime(
      Math.floor((diff / (1000 * 60 * 60)) % 24).toString()
    );
    const minutes = formatTime(Math.floor((diff / 1000 / 60) % 60).toString());
    const seconds = formatTime(Math.floor((diff / 1000) % 60).toString());
    setTime({ hours, minutes, seconds });
  }, [date, formatTime]);

  useEffect(() => {
    const interval = setInterval(getTime, 1000);

    return () => clearInterval(interval);
  }, [getTime]);

  return (
    <RootContainer>
      {time.hours === "-1"
        ? "00:00" // Fix out of sync cloud and local time 
        : `${time.hours === "00" ? "" : `${time.hours}:`}${time.minutes}:${
            time.seconds
          }`}
    </RootContainer>
  );
});

export default Timer;
